module.exports = __webpack_public_path__ + "static/media/πιστεύω_img.b221c022.JPG";